import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import team_integration_schemas from '../../../../configs/team-integration-schemas';
import { showChat } from '../../../../utils/liveChat';
import Badge from '../../../common/base/Badge';
import Button, { PlaceholderButton } from '../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../common/base/Card';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import Dropdown from '../../../common/Dropdown';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { DashboardContext } from '../DashboardContext';
const ExportDropdown = () => {
  const $ = _c(13);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    subscription
  } = useContext(DashboardContext);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.team_integrations.list();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.team_integrations) {
    t1 = () => HookdeckAPI.team_integrations.list();
    $[1] = HookdeckAPI.team_integrations;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: integrations
  } = useSWR(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: 412
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text m={{
      b: 4
    }}>Export metrics in realtime to your observability tool of choice.</Text>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      direction: "column",
      gap: 3
    };
    t5 = Object.entries(team_integration_schemas).filter(_temp);
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== integrations?.models || $[8] !== subscription) {
    t6 = <Div flex={t4}>{t5.map(t7 => {
        const [key, schema_0] = t7;
        const existing_integration = integrations?.models.find(i => i.provider === key);
        return <StyledCard key={key} flex={{
          justify: "space-between"
        }} p={{
          l: 3,
          r: !existing_integration ? 2 : 3,
          y: 2
        }}><Div flex={{
            align: "center"
          }}><Icon icon={schema_0.icon} small={true} m={{
              r: 2
            }} /><Text semi={true}>{schema_0.label}</Text></Div>{!subscription.features.includes("metrics_export") ? <Button to="/settings/organization/plans?highlight=metrics" outline={true} icon="upgrade">Upgrade to connect</Button> : existing_integration ? <Badge subtle={true} success={true} m={{
            l: 2,
            y: 1
          }}>Connected</Badge> : <Button to={`/settings/project/integrations/${key}/connect`} outline={true} icon="connect">Connect</Button>}</StyledCard>;
      })}</Div>;
    $[7] = integrations?.models;
    $[8] = subscription;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <PlaceholderButton m={{
      t: 3
    }} p={{
      y: 2.5
    }} onClick={showChat}>Request a new integration</PlaceholderButton>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <Dropdown outline={true} expand_icon="chevron_down" label="Metrics Export" icon="export"><StyledCardSection p={4} w={t2}>{t3}{t6}{t7}</StyledCardSection></Dropdown>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default ExportDropdown;
function _temp(t0) {
  const [, schema] = t0;
  return schema.features.includes("metrics");
}